// import React, { useState, useEffect } from "react";
// import MenCollection from "../../components/NewArrivals";
// import WomanCollection from "../../components/WomanCollection";
// import { api } from "../../api/api";
import {
  // Home_banner_url,
  limited_time_deal_api,
  // Mens_adv_url,
  new_arrival_api,
} from "../../api/urls";
// import Loading from "../../components/Loading";
// import { useNavigate } from "react-router-dom";

// import Banner1 from "../../Assests/PNG.png";
// import Banner2 from "../../Assests/img2.png";
// import Banner3 from "../../Assests/img3.png";

import "../main/main.css";
// import useFetch from "../../hooks/useFetch";
import HomeHeroSlider from "./HeroSlider";
// import NewArrivals from "../../components/ProdListing";
import ProdListing from "../../components/ProdListing";

const Clothing = () => {
  // const [homeBannerData, setHomeBannerData] = useState();
  // const [banner, setBanner] = useState();
  // const [loading, setLoading] = useState(false);
  // const navigate = useNavigate();
  // useEffect(() => {
  //   setLoading(true);
  //   api
  //     .get(Home_banner_url)

  //     .then((response) => {
  //       if (response.data && response.data.data) {
  //         setHomeBannerData(response.data.data);
  //       } else {
  //         console.error("Error: Image URL not found in the response");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching image:", error.response || error);
  //     })
  //     .finally(() => setLoading(false));
  // }, []);

  // useEffect(() => {
  //   const fetchImage2 = async () => {
  //     setLoading(true);
  //     try {
  //       const response2 = await api.get(Mens_adv_url);

  //       const adImage2 = response2.data;
  //       setBanner(adImage2);
  //     } catch (error) {
  //       console.error(
  //         "Error fetching the second image:",
  //         error.response || error,
  //       );
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchImage2();
  // }, []);

  // if (loading) {
  //   return <Loading />;
  // }

  return (
    <div className="max-w-[90%] mx-auto pb-10">
      {/* Slider */}
      <HomeHeroSlider/>

      <div className="mb-14">
        <h1 className="text-2xl font-semibold mb-5"># New Arrivals</h1>
        <ProdListing api_url={new_arrival_api} />
      </div>
      <div className="my-14">
        <h1 className="text-2xl font-semibold mb-5"># Limited Time Deals</h1>
        <ProdListing api_url={limited_time_deal_api} />
      </div>
      {/* <div className="wrapper">
        <div className="banner-left">
          <img
            className="banner cursor-pointer"
            src={homeBannerData?.[2]?.ad_image || Banner1}
            onClick={() => {
              const productId =
                homeBannerData?.[2]?.products?.id ||
                homeBannerData?.[2]?.products;
              if (productId) {
                navigate(`/products/${productId}`);
              } else {
                console.warn("No product ID found for this banner");
              }
            }}
            alt="Banner 1"
          />
        </div>
        <div className="banner-right">
          <img
            className="banner-image-2 cursor-pointer"
            src={homeBannerData?.[1]?.ad_image || Banner2}
            alt="Banner 2"
            onClick={() => {
              const productId =
                homeBannerData?.[2]?.products?.id ||
                homeBannerData?.[2]?.products;
              if (productId) {
                navigate(`/products/${productId}`);
              } else {
                console.warn("No product ID found for this banner");
              }
            }}
          />

          <img
            className="banner-image-3 cursor-pointer"
            src={homeBannerData?.[0]?.ad_image || Banner3}
            alt="Banner 3"
            onClick={() => {
              const productId =
                homeBannerData?.[2]?.products?.id ||
                homeBannerData?.[2]?.products;
              if (productId) {
                navigate(`/products/${productId}`);
              } else {
                console.warn("No product ID found for this banner");
              }
            }}
          />
        </div>
      </div> */}

      {/* <div className="marquee-container orange">
        <div className="marquee-track">
          {[...Array(16)].map((_, i) => (
            <p key={i} className="marquee-text">
              NEW ARRIVALS
            </p>
          ))}
        </div>
      </div> */}

      {/* <MenCollection /> */}

      {/* <div className="marquee-container yellow">
        <div className="marquee-track slow">
          {[...Array(16)].map((_, i) => (
            <p key={i} className="marquee-text">
              20% OFF ON WOMEN'S TOP WEAR
            </p>
          ))}
        </div>
      </div> */}
      {/* 
      <div className="sale_banner cursor-pointer">
        <img
          src={banner?.[12]?.ad_image}
          alt="Sales Banner"
          onClick={() => navigate(`/products/${banner?.[12]?.products}`)}
        />
      </div>

      <WomanCollection />

      <div className="sales_banner2 cursor-pointer">
        <img
          src={banner?.[11]?.ad_image}
          alt="Sales Banner"
          onClick={() => navigate(`/products/${banner?.[11]?.products}`)}
        />
      </div> */}
      {/* {banner?.[0]?.ad_image && (
        <div className="sale_banner cursor-pointer">
          <img
            src={banner?.[0]?.ad_image}
            style={{ height: "50vh", objectFit:"cover" }}
            alt="Sales Banner"
            // onClick={() => navigate(`/products/${banner?.[12]?.products}`)}
            onClick={() => navigate(`/products/${banner?.[0]?.products}`)}
          />
        </div>
      )} */}

      {/* <WomanCollection /> */}
      {/* {banner?.[1]?.ad_image && (
        <div className="sales_banner2 cursor-pointer">
          <img
            src={banner?.[1]?.ad_image}
            style={{ height: "50vh", objectFit:"cover" }}
            alt="Sales Banner"
            onClick={() => navigate(`/products/${banner?.[1]?.products}`)}
          />
        </div>
      )} */}
    </div>
  );
};

export default Clothing;
